import React from "react";
import img1 from "./1.gif";
import img2 from "./2.gif";
import img3 from "./3.gif";
import img4 from "./4.gif";

export const image1 = <img src={img1} alt="img1" />;
export const image2 = <img src={img2} alt="img2" />;
export const image3 = <img src={img3} alt="img3" />;
export const image4 = <img src={img4} alt="img4" />;
